module.exports = __webpack_public_path__ + "static/media/4.3ce89fb5.svg";